import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import Globals from "../../globals.ts";
import RemotelyActionable from "./remotelyActionable.ts";
const unpressedTileIndex = 5;
const pressedTileIndex = 6;
/**
 * Pressure plate that activates remote elements when Rex stands on it.
 * Only Rex can trigger it; Chip is too small.
 */
class PressurePlate extends RemotelyActionable {
    constructor(pos, linkedActionable) {
        super(pos, unpressedTileIndex);
        this.isPressed = false;
        this.setCollision(false, false, false, false);
        this.mass = 0; // Not affected by gravity
        this.linkedActionable = linkedActionable;
    }
    update() {
        super.update();
        const rex = Globals.rex;
        if (rex && rex.pos.distance(this.pos) < 0.6) {
            // Rex is on the plate
            if (!this.isPressed) {
                this.isPressed = true;
                this.linkedActionable.action();
                this.tileInfo = LJS.tile(pressedTileIndex, tilesize);
            }
        }
        else {
            // Rex is not on the plate
            if (this.isPressed) {
                this.isPressed = false;
                this.linkedActionable.action();
                this.tileInfo = LJS.tile(unpressedTileIndex, tilesize);
            }
        }
    }
}
export default PressurePlate;
